import React, { useEffect, useRef } from 'react';
import Image from './Image'; // Import from your custom Image component

type Size = 'small' | 'large';

interface PolaroidProps {
  src: string;
  caption: string;
  background?: string;
  onClick?: () => void;
  isClickable?: boolean;
  size: Size;
}

const Polaroid: React.FC<PolaroidProps> = ({ src, caption, background, onClick, isClickable, size}) => {
  const imageRef = useRef<HTMLImageElement>(null);

  const SIZE_MAPPINGS: Record<Size, { width: number, height: number }> = {
    'small': {
      width: 110,
      height: 160,
    },
    'large': {
      width: 280,
      height: 320,
    }
  }

  const width = SIZE_MAPPINGS[size].width;
  const height = SIZE_MAPPINGS[size].height;

  useEffect(() => {
    const handleImageLoad = () => {
      if (imageRef.current) {
        imageRef.current?.style.setProperty('width', `${width - 20}px`);
        imageRef.current?.style.setProperty('height', `${height - 50}px`);
      }
    };

    if (imageRef.current) {
      handleImageLoad();
    }

    return () => {
      // Cleanup function (optional)
    };
  }, [src, size, width, height]);

  return (
    <div 
      className={`relative flex flex-col gap-2 overflow-hidden items-center text-center shadow-lg text-gray-900 border-gray-200 p-2 justify-between ${background} ${isClickable ? 'hover:bg-yellow-200' : ''} ${isClickable ? 'cursor-pointer' : ''}`}
      style={{ maxWidth: width }} 
      onClick={() => {isClickable && onClick && onClick()}}
    >
      <Image
        src={src} 
        alt={caption} 
        ref={imageRef} 
        className={`object-contain max-h-48`}
      />

      <span className="flex grow align-center justify-center items-center text-xl" style={{fontFamily: "Dancing Script", zIndex: 100}}>
        {caption}
      </span>
    </div>
  );
};

export default Polaroid;